// extracted by css-extract-rspack-plugin
export default {"customLayout":"customLayout-e9ogS6","tabs":"tabs-AQDW2o","tabsItem":"tabsItem-rN7c81","root":"root-DdA1xR"};